var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg trash",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,1.92H21.33L20.91.85,20.27.21C20.05,0,19.84,0,19.41,0h-7a.8.8,0,0,0-.64.21c-.42.22-.42.43-.64.64l-.64,1.07H3a.78.78,0,0,0-.64.21A1.59,1.59,0,0,0,2.13,3V4.91A.76.76,0,0,0,3,5.76H28.8a.79.79,0,0,0,.64-.21c.21-.22.43-.22.43-.64V3a.76.76,0,0,0-.22-.64A1.57,1.57,0,0,0,28.8,1.92ZM5.33,29.23a2.71,2.71,0,0,0,.86,1.92A3.83,3.83,0,0,0,8.32,32H23.47a2.73,2.73,0,0,0,2.13-.85,2.32,2.32,0,0,0,.85-1.92L27.73,8.11H4.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.aa9f57b9fec269c15e31987d02078ef8.svg";
export { ForwardRef as ReactComponent };